import { any } from "prop-types";
import axios from 'axios';
import {
    getMemberLookupUrl,
    getMemberLookupClientId,
    getMemberLookupClientSecret
} from "../../../utils/url-constant";

const getLookUpMember = (medicaidID:any, dateOfBirth:any, ssn:any) => {

    let url = getMemberLookupUrl();

    // =====================================================
    // TEMP STAGE TEST - USE THIS NOW
    // COMMENT THIS BLOCK AFTER TESTING
    // =====================================================
    url = url
        + "?medicaidID=01862688501"
        + "&dateOfBirth=2005-04-11"
        + "&ssn=506493836";

    // =====================================================
    // ORIGINAL CODE - RESTORE AFTER TESTING
    // UNCOMMENT THIS BLOCK AFTER COMMENTING TEMP BLOCK ABOVE
    // =====================================================
    // url = url
    //     + "?medicaidID=" + medicaidID
    //     + "&dateOfBirth=" + JSON.stringify([dateOfBirth].toString())
    //         .replaceAll(",","-")
    //         .replaceAll(/["']/g, "")
    //     + "&ssn=" + ssn;

    axios.defaults.baseURL = '';
    axios.defaults.headers.common['Content-type'] = "application/json";
    axios.defaults.headers.common['Accept'] = "*/*";
    axios.defaults.headers.common['X-IBM-Client-Id'] = getMemberLookupClientId();
    axios.defaults.headers.common['X-IBM-Client-Secret'] = getMemberLookupClientSecret();

    return axios.get(`${url}`);
}

const LookupMemberMedicaidIDService = {
    getLookUpMember
};

export default LookupMemberMedicaidIDService;